// extracted by mini-css-extract-plugin
export default {"pageSpinner":"pageSpinner_pageSpinner__B-6h0","pageSpinnerTitle":"pageSpinner_pageSpinnerTitle__q4-o4","spinner":"pageSpinner_spinner__dFIXY"};